// telemetry clients
import amplitudeFactory from "@teaming/common-vendor/amplitude";
import intercomFactory from "@teaming/common-vendor/intercom";
import fullstoryTelemetryFactory from "@teaming/common-vendor/fullstory";

// telemetry modules
import onboardingFactory from "./onboarding";
import sessionFactory from "./session";
import oneononeFactory from "./oneonone";
import teamFactory from "./team";
import gokrFactory from "./gokr";
import userFactory from "./user";
import inboxFactory from "./inbox";

export default ( { config, foundation, } ) => {
	const amplitude = amplitudeFactory( config );
	const intercom = intercomFactory();
	const fullStory = fullstoryTelemetryFactory();

	let _currentUser = null;
	const currentUser = () => _currentUser;

	return {
		_amplitude: amplitude,
		_intercom: intercom,
		scopeToUser( userProfile, customAttributes = {}, { forceRescope, } = { forceRescope: false, } ) {
			_currentUser = { ...userProfile, };
			amplitude.setAmplitudeUser( currentUser() );
			intercom.update( currentUser(), customAttributes );
			// re-identifying an identified user will split the user's session
			// https://help.fullstory.com/hc/en-us/articles/360020828113-FS-identify-Identifying-users
			if ( !fullStory.isIdentified() || forceRescope ) {
				fullStory.identify( currentUser() );
			}
		},
		dispose() {
			_currentUser = null;
			amplitude.setAmplitudeUser( null );
			intercom.shutdown();
		},
		onboarding: onboardingFactory( { currentUser, amplitude, intercom, } ),
		session: sessionFactory( { currentUser, foundation, amplitude, intercom, } ),
		oneonone: oneononeFactory( { currentUser, amplitude, intercom, } ),
		team: teamFactory( { currentUser, amplitude, intercom, } ),
		gokr: gokrFactory( { currentUser, amplitude, intercom, } ),
		user: userFactory( { currentUser, amplitude, intercom, } ),
		inbox: inboxFactory( { currentUser, amplitude, intercom, } ),
	};
};
